if(!customElements.get('first-addtocart-popup')) {
  customElements.define('first-addtocart-popup', class FirstAddToCartPopup extends HTMLElement {
    constructor() {
      super();
      this.popupCloseBtn = this.querySelector('.popup-close-button');
    }

    connectedCallback() {
      this.swymNotification = document.querySelector("swym-notification");
      this.variantOptions = this.querySelectorAll('component-product-options');
      this.addEventListeners();
    }

    addEventListeners() {
      this.popupCloseBtn ? this.popupCloseBtn.addEventListener('click', this.handleClick.bind(this)) : null;
      this.variantOptions ? this.variantOptions.forEach(option => option.addEventListener("click", (e) => this.showAddtoCartNotificationMessage.call(this, e))) : null;
    }

    handleClick(e) {
      this.removeAttribute('open');
    }

    showAddtoCartNotificationMessage(e) {
      let target = e.target;
      let availableOption = target.closest('span[data-status="addtocart"]') || target.closest('span[data-status="presale"]');
      let componentProductOptions = target.closest('.component-product-options-popup');
      let isClickedFromWishlistButton = componentProductOptions && componentProductOptions.dataset.wishlistPopup;
      if (availableOption && !isClickedFromWishlistButton) {
        this.swymNotification.setAttribute('data-position', 'from-popup');
        let title = availableOption.dataset.title;
        let size = availableOption.dataset.variantTitle;
        let img =  availableOption.dataset.modelImage;
        size && img
          ? this.swymNotification.show({
              text: `<strong>${title} - ${size}</strong> is added to <strong>Cart</strong> successfully`,
              imageURL: img
            })
          : null;
      }
    }

    open() {
      this.setAttribute('open', true);
      if(!this.options) {
        this.options = this.querySelectorAll('.component-product-options-boxes');
        for (const option of this.options) {
          option.checkWidth();
        }
      }
      sessionStorage.setItem('isFirstAddToCartPopupOpened', true);
    }
  })
}
